var exports = {
  "n": "x04b3a21e--c2c519--link",
};

module.exports = exports;
